import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ViewIcon from '../../utils/media/icons/view_icon.png';
import { adminChangePassword } from '../../api/auth';

const ChangePassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [currentError, setCurrentError] = useState('');
    const [newError, setNewError] = useState('');
    const [confirmError, setConfirmError] = useState('');

    const [showCurrent, setShowCurrent] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const validatePassword = (pw) =>
        /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(pw);

    const handleSubmit = (e) => {
        e.preventDefault();
        setCurrentError('');
        setNewError('');
        setConfirmError('');

        let ok = true;
        if (!currentPassword) {
            setCurrentError('Current password is required.');
            ok = false;
        }
        if (!newPassword) {
            setNewError('New password is required.');
            ok = false;
        } else if (!validatePassword(newPassword)) {
            setNewError('Min 8 chars with 1 uppercase, 1 number, 1 special character.');
            ok = false;
        } else if (newPassword === currentPassword) {
            setNewError('New password must be different from current password.');
            ok = false;
        }
        if (!confirmPassword) {
            setConfirmError('Please confirm your new password.');
            ok = false;
        } else if (confirmPassword !== newPassword) {
            setConfirmError('Passwords do not match.');
            ok = false;
        }

        if (ok) {
            adminChangePassword(
                { currentPassword, newPassword, confirmPassword },
                dispatch,
                navigate,
                toast
            );
        }
    };

    return (
        <div className='w-full px-6 py-8 flex justify-center'>
            <div className='w-full max-w-2xl bg-white rounded-3xl shadow-lg px-10 py-10'>
                <h1 className='text-primary text-3xl font-semibold'>Change Password</h1>
                <p className='text-secondary text-base mt-2'>
                    Rotate your admin password. Min 8 characters with at least one
                    uppercase letter, one number, and one special character.
                </p>

                <form className='w-full mt-8 flex flex-col gap-5' onSubmit={handleSubmit}>
                    {/* Current password */}
                    <div className='flex flex-col w-full'>
                        <span className={`${currentError ? 'text-red' : 'text-black'} font-bold text-base`}>Current Password</span>
                        <div className='w-full relative'>
                            <input
                                type={showCurrent ? 'text' : 'password'}
                                required
                                placeholder='Enter current password'
                                className={`border ${currentError ? 'border-red' : 'border-secondary'} rounded-md px-3 py-2 outline-primary w-full`}
                                value={currentPassword}
                                onChange={(e) => setCurrentPassword(e.target.value)}
                                autoComplete='current-password'
                            />
                            <button
                                type='button'
                                className='absolute right-1 top-2 rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7 max-w-8'
                                onClick={() => setShowCurrent(!showCurrent)}
                            >
                                <img src={ViewIcon} alt='view' />
                            </button>
                        </div>
                        {currentError && <p className='text-red text-base'>{currentError}</p>}
                    </div>

                    {/* New password */}
                    <div className='flex flex-col w-full'>
                        <span className={`${newError ? 'text-red' : 'text-black'} font-bold text-base`}>New Password</span>
                        <div className='w-full relative'>
                            <input
                                type={showNew ? 'text' : 'password'}
                                required
                                placeholder='Enter new password'
                                className={`border ${newError ? 'border-red' : 'border-secondary'} rounded-md px-3 py-2 outline-primary w-full`}
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                autoComplete='new-password'
                            />
                            <button
                                type='button'
                                className='absolute right-1 top-2 rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7 max-w-8'
                                onClick={() => setShowNew(!showNew)}
                            >
                                <img src={ViewIcon} alt='view' />
                            </button>
                        </div>
                        {newError && <p className='text-red text-base'>{newError}</p>}
                    </div>

                    {/* Confirm password */}
                    <div className='flex flex-col w-full'>
                        <span className={`${confirmError ? 'text-red' : 'text-black'} font-bold text-base`}>Confirm New Password</span>
                        <div className='w-full relative'>
                            <input
                                type={showConfirm ? 'text' : 'password'}
                                required
                                placeholder='Re-enter new password'
                                className={`border ${confirmError ? 'border-red' : 'border-secondary'} rounded-md px-3 py-2 outline-primary w-full`}
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                autoComplete='new-password'
                            />
                            <button
                                type='button'
                                className='absolute right-1 top-2 rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7 max-w-8'
                                onClick={() => setShowConfirm(!showConfirm)}
                            >
                                <img src={ViewIcon} alt='view' />
                            </button>
                        </div>
                        {confirmError && <p className='text-red text-base'>{confirmError}</p>}
                    </div>

                    <div className='flex justify-end gap-3 mt-4'>
                        <button
                            type='button'
                            onClick={() => navigate(-1)}
                            className='px-6 py-2 text-base font-bold rounded-md border-2 border-secondary text-secondary hover:bg-gray-50'
                        >
                            Cancel
                        </button>
                        <button
                            type='submit'
                            className='bg-primary px-8 py-2 text-base text-white font-bold rounded-md border hover:bg-white hover:border hover:text-primary'
                        >
                            Update Password
                        </button>
                    </div>
                </form>
            </div>

            <ToastContainer position='bottom-right' autoClose={1500} />
        </div>
    );
};

export default ChangePassword;
